import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '../../lib/supabase';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider';
import styles from './Login.module.scss';
import { useMediaQuery, useTheme } from '@mui/material';

export const Login = () => {
  const navigate = useNavigate();
  const { session } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (session) {
      navigate('/');
    }
  }, [session, navigate]);

  return (
    <div className={styles.authContainer}>
      <img src={'/logo.svg'} className={styles.logo} alt="logo" />
      <Auth
        supabaseClient={supabase}
        appearance={{
          theme: ThemeSupa,
          variables: {
            default: {
              colors: {
                brand: '#1976d2',
                brandAccent: '#1976d2',
              },
              space: {
                inputPadding: isMobile ? '12px' : '16px',
              },
              fontSizes: {
                baseButtonSize: isMobile ? '14px' : '16px',
                baseInputSize: isMobile ? '14px' : '16px',
              },
              radii: {
                borderRadiusButton: '4px',
                buttonBorderRadius: '4px',
                inputBorderRadius: '4px',
              },
            },
          },
          className: {
            container: 'supabase-auth-ui_ui-container',
            button: 'supabase-auth-ui_ui-button',
            input: 'supabase-auth-ui_ui-input',
          },
        }}
        providers={[]}
        showLinks={false}
      />
    </div>
  );
};
